// extracted by mini-css-extract-plugin
export default {"area-action":"areaAction_area-action__iEn-F"};